import { apiPost } from 'utils/request';
import HOST from 'utils/globals';

export const inviteUsers = body => apiPost(`${HOST}/invitedUsers`, body);
